// US States coordinates for ECharts scatter map visualization
// Each state with its center coordinates (lon, lat) for plotting

export const US_STATE_COORDS: Record<string, [number, number]> = {
    'AL': [-86.9023, 32.3182],
    'AK': [-153.4937, 64.2008],
    'AZ': [-111.0937, 34.0489],
    'AR': [-91.8318, 34.7465],
    'CA': [-119.4179, 36.7783],
    'CO': [-105.3111, 39.0598],
    'CT': [-72.7554, 41.5978],
    'DE': [-75.5277, 38.9108],
    'FL': [-81.5158, 27.6648],
    'GA': [-82.9071, 32.1656],
    'HI': [-155.5828, 19.8968],
    'ID': [-114.7420, 44.0682],
    'IL': [-89.3985, 40.6331],
    'IN': [-86.1349, 40.2672],
    'IA': [-93.0977, 41.8780],
    'KS': [-98.4842, 39.0119],
    'KY': [-84.2700, 37.8393],
    'LA': [-91.9623, 30.9843],
    'ME': [-69.4455, 45.2538],
    'MD': [-76.6413, 39.0458],
    'MA': [-71.3824, 42.4072],
    'MI': [-84.5555, 44.3148],
    'MN': [-94.6859, 46.7296],
    'MS': [-89.3985, 32.3547],
    'MO': [-91.8318, 37.9643],
    'MT': [-110.3626, 46.8797],
    'NE': [-99.9018, 41.4925],
    'NV': [-116.4194, 38.8026],
    'NH': [-71.5724, 43.1939],
    'NJ': [-74.4057, 40.0583],
    'NM': [-105.8701, 34.5199],
    'NY': [-75.4999, 43.2994],
    'NC': [-79.0193, 35.7596],
    'ND': [-100.4659, 47.5515],
    'OH': [-82.9071, 40.4173],
    'OK': [-97.0929, 35.0078],
    'OR': [-120.5542, 43.8041],
    'PA': [-77.1945, 41.2033],
    'RI': [-71.4774, 41.5801],
    'SC': [-81.1637, 33.8361],
    'SD': [-99.9018, 43.9695],
    'TN': [-86.5804, 35.5175],
    'TX': [-99.9018, 31.9686],
    'UT': [-111.0937, 39.3210],
    'VT': [-72.5778, 44.5588],
    'VA': [-78.1699, 37.4316],
    'WA': [-120.7401, 47.7511],
    'WV': [-80.4549, 38.5976],
    'WI': [-89.6165, 43.7844],
    'WY': [-107.2903, 43.0760],
    'DC': [-77.0369, 38.9072],
    'PR': [-66.5901, 18.2208],
    'GU': [144.7937, 13.4443],
    'VI': [-64.8963, 18.3358],
    // Full state names mapping
    'Alabama': [-86.9023, 32.3182],
    'Alaska': [-153.4937, 64.2008],
    'Arizona': [-111.0937, 34.0489],
    'Arkansas': [-91.8318, 34.7465],
    'California': [-119.4179, 36.7783],
    'Colorado': [-105.3111, 39.0598],
    'Connecticut': [-72.7554, 41.5978],
    'Delaware': [-75.5277, 38.9108],
    'Florida': [-81.5158, 27.6648],
    'Georgia': [-82.9071, 32.1656],
    'Hawaii': [-155.5828, 19.8968],
    'Idaho': [-114.7420, 44.0682],
    'Illinois': [-89.3985, 40.6331],
    'Indiana': [-86.1349, 40.2672],
    'Iowa': [-93.0977, 41.8780],
    'Kansas': [-98.4842, 39.0119],
    'Kentucky': [-84.2700, 37.8393],
    'Louisiana': [-91.9623, 30.9843],
    'Maine': [-69.4455, 45.2538],
    'Maryland': [-76.6413, 39.0458],
    'Massachusetts': [-71.3824, 42.4072],
    'Michigan': [-84.5555, 44.3148],
    'Minnesota': [-94.6859, 46.7296],
    'Mississippi': [-89.3985, 32.3547],
    'Missouri': [-91.8318, 37.9643],
    'Montana': [-110.3626, 46.8797],
    'Nebraska': [-99.9018, 41.4925],
    'Nevada': [-116.4194, 38.8026],
    'New Hampshire': [-71.5724, 43.1939],
    'New Jersey': [-74.4057, 40.0583],
    'New Mexico': [-105.8701, 34.5199],
    'New York': [-75.4999, 43.2994],
    'North Carolina': [-79.0193, 35.7596],
    'North Dakota': [-100.4659, 47.5515],
    'Ohio': [-82.9071, 40.4173],
    'Oklahoma': [-97.0929, 35.0078],
    'Oregon': [-120.5542, 43.8041],
    'Pennsylvania': [-77.1945, 41.2033],
    'Rhode Island': [-71.4774, 41.5801],
    'South Carolina': [-81.1637, 33.8361],
    'South Dakota': [-99.9018, 43.9695],
    'Tennessee': [-86.5804, 35.5175],
    'Texas': [-99.9018, 31.9686],
    'Utah': [-111.0937, 39.3210],
    'Vermont': [-72.5778, 44.5588],
    'Virginia': [-78.1699, 37.4316],
    'Washington': [-120.7401, 47.7511],
    'West Virginia': [-80.4549, 38.5976],
    'Wisconsin': [-89.6165, 43.7844],
    'Wyoming': [-107.2903, 43.0760],
    'District of Columbia': [-77.0369, 38.9072],
    'Puerto Rico': [-66.5901, 18.2208],
    'Guam': [144.7937, 13.4443],
    'Virgin Islands': [-64.8963, 18.3358],
};

// State name abbreviation mapping
export const STATE_ABBR_TO_NAME: Record<string, string> = {
    'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas',
    'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware',
    'FL': 'Florida', 'GA': 'Georgia', 'HI': 'Hawaii', 'ID': 'Idaho',
    'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas',
    'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
    'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi',
    'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada',
    'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York',
    'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio', 'OK': 'Oklahoma',
    'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
    'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah',
    'VT': 'Vermont', 'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia',
    'WI': 'Wisconsin', 'WY': 'Wyoming', 'DC': 'District of Columbia',
    'PR': 'Puerto Rico', 'GU': 'Guam', 'VI': 'Virgin Islands'
};
